import { ArrowRight, XCircle } from "lucide-react";
import { Link } from "react-router-dom";
import SiteLayout from "../../components/layout/SiteLayout";
import { focusRing } from "../../components/ui/focusRing";

function UpgradeCancel() {
  return (
    <SiteLayout navVariant="inner" footerVariant="home">
      <main className="flex-1 flex items-center justify-center px-6 pt-24 pb-12">
        <div className="max-w-md w-full bg-white rounded-3xl border border-orange-200 shadow-sm p-8 text-center">
          <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-8 h-8 text-brand-orange" />
          </div>
          <h1 className="text-3xl font-bold text-stone-800 mb-4">Checkout cancelled</h1>
          <p className="text-stone-600 mb-8">
            No worries! Use{" "}
            <code className="bg-orange-50 text-brand-orange px-2 py-1 rounded text-sm font-mono border border-orange-200">
              !upgrade
            </code>{" "}
            in Slack if you change your mind.
          </p>
          <Link
            to="/"
            className={`inline-flex items-center gap-2 text-stone-700 hover:text-brand-orange font-semibold transition-colors ${focusRing}`}
          >
            Return to homepage
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </main>
    </SiteLayout>
  );
}

export default UpgradeCancel;
